export default "__VITE_ASSET__DlS8MV$Y__"